import React, { useState } from "react";
import {
  FormControl, InputLabel, Select, MenuItem, Dialog,
  DialogTitle, DialogContent, DialogActions, Button,
  TextField, CircularProgress, Box
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function SelectConAggiunta({
  label, value, onChange, items, loading, onAggiungi,
  multiple = false, required = false
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [nuovoValore, setNuovoValore] = useState("");
  const [saving, setSaving] = useState(false);

  async function handleAggiungi() {
    if (!nuovoValore.trim()) return;
    setSaving(true);
    await onAggiungi(nuovoValore.trim());
    setSaving(false);
    setNuovoValore("");
    setDialogOpen(false);
  }

  return (
    <>
      <FormControl fullWidth required={required}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          label={label}
          multiple={multiple}
        >
          {loading ? (
            <MenuItem disabled>
              <CircularProgress size={20} />
            </MenuItem>
          ) : (
            items.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.nome}
              </MenuItem>
            ))
          )}
          <MenuItem
            onClick={(e) => { e.stopPropagation(); setDialogOpen(true); }}
            sx={{ color: "primary.main", fontWeight: "bold" }}
          >
            <AddIcon fontSize="small" sx={{ mr: 1 }} />
            Aggiungi nuovo...
          </MenuItem>
        </Select>
      </FormControl>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Aggiungi {label}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label={label}
            value={nuovoValore}
            onChange={(e) => setNuovoValore(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleAggiungi()}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Annulla</Button>
          <Button
            onClick={handleAggiungi}
            variant="contained"
            disabled={saving || !nuovoValore.trim()}
          >
            {saving ? <CircularProgress size={20} /> : "Aggiungi"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}